<template>
    <div>
        <!-- Navigation -->
        <nav class="navbar navbar-light bg-light static-top">
            <div class="container">
                <a class="navbar-brand navbar-landingpage" href="#">Traceable Maintenance Program</a>
                <div class="block">
                    <router-link :to="{name: 'login'}"
                                 class="btn btn-primary">{{$t('landingpage.SignIn')}}
                    </router-link>
                    <div class="dropdown pull-right">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-info dropdown-toggle"
                                data-toggle="dropdown" id="dropdownMenuButton" type="button">
                            {{$i18n.locale}}
                        </button>
                        <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                            <a :key="`Lang${i}`" :value="lang" @click="setLocale(lang.value)" class="dropdown-item"
                               href="#" v-for="(lang, i) in langs">{{ lang.name }} <i style="color: #8080807d" v-if="$i18n.locale == lang.value" class="fa fa-check"></i> </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>

        <!-- Masthead -->
        <header class="masthead text-white text-center">
            <div class="overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-xl-9 mx-auto">
                        <h1 class="mb-5">{{$t('landingpage.banner1.Title')}}</h1>
                        <div class="col text-center">
                            <a class="btn btn-lg btn-primary" href="https://indusclean.com">{{$t('landingpage.banner1.Button')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <!-- Icons Grid -->
        <section class="features-icons bg-light text-center">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                            <img class="zoom" src="@/assets/img/landingpage/icon1.png" />
                            <h3>{{$t('landingpage.sectionIcons.column1.Title')}}</h3>
                            <p class="lead mb-0">{{$t('landingpage.sectionIcons.column1.Content')}}</p>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                            <img class="zoom" src="@/assets/img/landingpage/icon2.png" />
                            <h3>{{$t('landingpage.sectionIcons.column2.Title')}}</h3>
                            <p class="lead mb-0">{{$t('landingpage.sectionIcons.column2.Content')}}</p>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="features-icons-item mx-auto mb-0 mb-lg-3">
                            <img class="zoom" src="@/assets/img/landingpage/icon3.png" />
                            <h3>{{$t('landingpage.sectionIcons.column3.Title')}}</h3>
                            <p class="lead mb-0">{{$t('landingpage.sectionIcons.column3.Content')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Image Showcases -->
        <section class="showcase">
            <div class="container-fluid p-0">
                <div class="row no-gutters">

                    <div class="col-lg-6 order-lg-2 text-white showcase-img showcase-1"></div>
                    <div class="col-lg-6 order-lg-1 my-auto showcase-text">
                        <h2>{{$t('landingpage.section1.Title')}}</h2>
                        <p class="lead mb-0">{{$t('landingpage.section1.Content')}}</p>
                        <p class="lead mb-0 mt-3">{{$t('landingpage.section1.Content2')}}</p>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col-lg-6 text-white showcase-img showcase-2"></div>
                    <div class="col-lg-6 my-auto showcase-text">
                        <h2>{{$t('landingpage.section2.Title')}}</h2>
                        <p class="lead mb-0">{{$t('landingpage.section2.Content')}}</p>
                        <p class="lead mb-0 mt-3">{{$t('landingpage.section2.Content2')}}</p>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col-lg-6 order-lg-2 text-white showcase-img showcase-3"></div>
                    <div class="col-lg-6 order-lg-1 my-auto showcase-text">
                        <h2>{{$t('landingpage.section3.Title')}}</h2>
                        <p class="lead mb-0">{{$t('landingpage.section3.Content')}}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Testimonials -->
        <section class="testimonials text-center bg-light">
            <div class="container">
                <h2 class="mb-5">{{$t('landingpage.sectionExamples.Title')}}</h2>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="testimonial-item mx-auto mb-5 mb-lg-0">
                            <img alt="" class="img-fluid rounded-circle mb-3"
                                 src="../assets/img/landingpage/ballvalves.jpg">
                            <h5>{{$t('landingpage.sectionExamples.Example1')}}</h5>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="testimonial-item mx-auto mb-5 mb-lg-0">
                            <img alt="" class="img-fluid rounded-circle mb-3"
                                 src="../assets/img/landingpage/flamearrestor.jpg">
                            <h5>{{$t('landingpage.sectionExamples.Example2')}}</h5>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="testimonial-item mx-auto mb-5 mb-lg-0">
                            <img alt="" class="img-fluid rounded-circle mb-3"
                                 src="../assets/img/landingpage/pressurevalves.jpg">
                            <h5>{{$t('landingpage.sectionExamples.Example3')}}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Call to Action -->
        <section class="call-to-action text-white text-center">
            <div class="overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-xl-9 mx-auto">
                        <h2 class="mb-4">{{$t('landingpage.banner2.Title')}}</h2>
                        <div class="col text-center">
                            <a class="btn btn-lg btn-primary" href="https://indusclean.com">{{$t('landingpage.banner2.Button')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Footer -->
        <footer class="footer bg-light">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 h-100 text-center text-lg-left my-auto">
                        <p class="text-muted small mb-4 mb-lg-0">&copy; IndusClean 2019. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<style>
    body {
        font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-weight: 700;
    }

    header.masthead {
        position: relative;
        background-color: #343a40;
        background: url("~@/assets/img/landingpage/tankstorage.jpeg") no-repeat center center;
        background-size: cover;
        padding-top: 8rem;
        padding-bottom: 8rem;
    }

    header.masthead .overlay {
        position: absolute;
        background-color: #212529;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        opacity: 0.3;
    }

    header.masthead h1 {
        font-size: 2rem;
    }

    @media (min-width: 768px) {
        header.masthead {
            padding-top: 12rem;
            padding-bottom: 12rem;
        }

        header.masthead h1 {
            font-size: 3rem;
        }
    }

    .showcase .showcase-text {
        padding: 3rem;
    }

    .showcase .showcase-img {
        min-height: 30rem;
        background-size: cover;
    }

    @media (min-width: 768px) {
        .showcase .showcase-text {
            padding: 7rem;
        }
    }

    .features-icons {
        padding-top: 7rem;
        padding-bottom: 7rem;
    }

    .features-icons .features-icons-item {
        max-width: 20rem;
    }

    .features-icons .features-icons-item .features-icons-icon {
        height: 7rem;
    }

    .features-icons .features-icons-item .features-icons-icon i {
        font-size: 4.5rem;
    }

    .features-icons .features-icons-item:hover .features-icons-icon i {
        font-size: 5rem;
    }

    .zoom {
        transition: all 500ms;
    }

    .zoom:hover {
        transition: all 500ms;
        transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    }

    .testimonials {
        padding-top: 7rem;
        padding-bottom: 7rem;
    }

    .testimonials .testimonial-item {
        max-width: 18rem;
    }

    .testimonials .testimonial-item img {
        max-width: 12rem;
        box-shadow: 0px 5px 5px 0px #adb5bd;
    }

    .call-to-action {
        position: relative;
        background-color: #343a40;
        background: url("~@/assets/img/landingpage/tankstorage.jpeg") no-repeat center center;
        background-size: cover;
        padding-top: 7rem;
        padding-bottom: 7rem;
    }

    .call-to-action .overlay {
        position: absolute;
        background-color: #212529;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        opacity: 0.3;
    }

    footer.footer {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    .showcase-1 {
        background: url("~@/assets/img/landingpage/followup.jpg") no-repeat center center;
    }

    .showcase-2 {
        background: url("~@/assets/img/landingpage/legalreq.jpg") no-repeat center center;
    }

    .showcase-3 {
        background: url("~@/assets/img/landingpage/multistep.jpg") no-repeat center center;
    }

</style>
<script>
    export default {
        name: 'locale-changer',
        data() {
            return {
                langs: [
                    {
                        name: 'Nederlands',
                        value: 'nl'
                    },
                    {
                        name: 'English',
                        value: 'en'
                    }
                ]
            }
        },
        methods: {
            setLocale(lang) {
                this.$i18n.locale = lang
            }
        }
    }
</script>
